module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_02_6NV26_1SA_GLU.f8f79851.png";